import React, {useState} from "react";
import {Button} from 'react-bootstrap';
import Checkbox from '../../common/CheckBox';
import {useSelector} from "react-redux";
import {useTranslation} from "../../../hooks/useTranslation";

const TableHead = (props) => {
    const columns = props.headColumns;
    const [toggleColsDd, setToggleColsDd] = useState(false);
    const {t} = useTranslation();
    const reduxSortOptions = useSelector((state) => state.SEARCH_TABLE).sortOptions;
    const sortOptions = props.sortOptions || reduxSortOptions;

    const selectAll = (e, type, rowKey) => {
        if (props.allowSelectionCheckbox || props.tableName === "Product Variants") {
            props.headColumns['0'].inputType.select(e, type, rowKey);
        }
    }

    const toggleColumnsDropDown = () => {
        setToggleColsDd(!toggleColsDd);
    }

    const handleTableShowHideColumns = (field) => {
        props.toggleColumns && props.toggleColumns(field);
    }

    // Permanently Save Table in Device Local Storage
    const permanentlySaveTable = () => {
        props.saveToggleColumns && props.saveToggleColumns();
        setToggleColsDd(false);
    }

    return (
        <thead>
        <tr>
            {columns && columns.map((th, idx) => {
                if (th.field === "select_checkbox") {
                    return (
                        <th style={{width: "3%"}} className={th.field} key={idx}>
                            <input type="checkbox"
                                   style={{zoom: "1.3"}}
                                   defaultChecked={Array.isArray(props?.checkedRows) && ((props.checkedRows.length === 1 && props.checkedRows[0] === -1) || (props.checkedRows.length === props.totalItems && !props.checkedRows.some((el) => el === -1)))}
                                   onClick={(e) => selectAll(e, 'selectAll', '0')}
                            />
                        </th>
                    )
                } else if (th.field === "actions") {
                    return (
                        <th style={{maxWidth: `${th.width}`, important: th.width ? 'true' : 'false'}} className={`position-relative ` + th.field} key={idx}>
                            {props.tableName !== 'Product Balance Report' && props.tableName !== 'Sales Balance Report' && props.tableName !== 'MyData Report' && props.tableName !== "MyData Report Buys" && props.tableName !== 'Sales Payment Report' && props.tableName !== 'Product Movement Report' && props.tableName !== 'Client Balance Report' && props.tableName !== 'Supplier Balance Report' ? th.name : ''}
                            {props.allowToggleColumns &&
                                <div className="et-columns-dropdown dropdown">
                                    <div className="dropdown-toggle" onClick={() => toggleColumnsDropDown()}>
                                        <i className="fas fa-bars"></i>
                                    </div>
                                    {toggleColsDd &&
                                        <ul className="dropdown-menu show">
                                            {props.tableName !== 'Product Balance Report' && props.tableName !== 'Sales Balance Sheet' && props.tableName !== 'MyData Report' && props.tableName !== "MyData Report Buys" && props.tableName !== 'Client Payments Report' && props.tableName !== 'Product Movements Report' && props.tableName !== 'Sales Balance Sheet' && props.tableName !== 'Buys Balance Sheet' && props.tableName !== 'Supplier Payments Report' &&
                                                <li className="dropdown-item">
                                                    <Button onClick={() => permanentlySaveTable()} variant="primary" size="small">{t("General.saveColumns")}</Button>
                                                </li>
                                            }
                                            {
                                                columns.map((col, ind) => {
                                                    return (
                                                        col.field !== 'actions' && col.field !== 'select_checkbox' &&
                                                        <li className="dropdown-item">
                                                            <Checkbox
                                                                key={`ddColItem-${ind}`}
                                                                text={col.name}
                                                                className="mb-0 mr-2 centered-checkbox"
                                                                name={col.field}
                                                                defaultValue={!col.hiddenColumn}
                                                                value={true}
                                                                onChange={() => handleTableShowHideColumns(col.field)}
                                                            />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }
                                </div>
                            }
                        </th>
                    )
                } else if (!th.hiddenColumn) {
                    // Special Case where table field does not match with model.
                    let sortField = sortOptions[props.tableName]?.sortField;
                    if (th.field === "preNumberAndNumber") {
                        sortField = "preNumberAndNumber";
                    }
                    return (
                        <th key={idx}
                            id={(props?.emronPaymentsMonth && th.field === props?.emronPaymentsMonth ? "emronPaymentsSelected" : "")}
                            className={th.field + (props?.emronPaymentsMonth && th.field === props?.emronPaymentsMonth ? " emronPaymentsSelected" : "")}
                            style={{width: props?.fixedLayout ? `${th.width}` : "auto",
                                maxWidth: `${th.width}`,
                                important: th.width ? 'true' : 'false',
                                padding: props?.fixedLayout ? `10px 2px` : "10px",
                                cursor: props.allowSorting ? "pointer" : "default"}}
                            onClick={(props?.allowSorting && props?.handleChangeSortMethod) ? (e) => props.handleChangeSortMethod(e, th.field) : () => {}}
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                alignItems: "center",
                                maxWidth: "100%",
                                position: "relative"
                            }}>
                                <span className={props?.fixedLayout ? "tdelement" : "text-align--center"}>{th.name}</span>
                                {(sortOptions[props.tableName]?.sortMethod && sortField === th.field) && (
                                    <img src={"assets/images/select-down-icon.png"}
                                         style={{width: "10px", height: "8px", marginLeft: "5px",
                                             transform: sortOptions[props.tableName]?.sortMethod  === "ASC" ? "rotate(180deg)" : "rotate(0deg)"
                                         }}
                                         alt={"arrow-icon"}
                                    />
                                )}
                            </div>
                        </th>
                    )
                } else {
                    return <React.Fragment></React.Fragment>
                }
            })}
        </tr>
        </thead>
    )
}
export default TableHead;
